import { BaseCrudService } from "@/services/base";
import { AxiosRequestConfig } from "axios";
import moment, { Moment } from "moment";

export interface Stats {
    [key: string]: any;
}

class DashboardService extends BaseCrudService<Stats> {
    constructor() {
        super({
            apiPrefix: "dash",
            entityName: "stat",
        });
    }

    async getOffices(axiosOptions?: AxiosRequestConfig): Promise<any> {
        try {
            const res = await this.axios.get<any>(`/offices`, axiosOptions);
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not retrieve statistics for offices: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }

    async getOffice(id: number, date: Moment, axiosOptions?: AxiosRequestConfig): Promise<any> {
        try {
            const res = await this.axios.get<any>(`/offices/${id}`, {
                params: {
                    date: date.format(moment.HTML5_FMT.DATE),
                },
                ...axiosOptions,
            });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not retrieve statistics for office: ${e.response?.data?.message || e.message}`,
            });
            throw e;
        }
    }
}

export const dashboardService = new DashboardService();
